import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { buildApiUrl } from '../config/apiConfig';
import { getResumesCount } from '../services/api';

const ResumeCountContext = createContext();

export const ResumeCountProvider = ({ children }) => {
  const { token, isAuthenticated } = useAuth();
  const [totalResumes, setTotalResumes] = useState(0);

  // Function to update count by change (increment/decrement)
  const updateResumeCount = (change) => {
    setTotalResumes(prev => prev + change);
  };

  // Function to set absolute count
  const setResumeCount = (count) => {
    setTotalResumes(count);
  };

  const refreshResumeCount = React.useCallback(async () => {
    if (isAuthenticated) {
      try {
        // unique:true ensures the badge always matches the deduplicated list
        const response = await getResumesCount({ unique: true });
        const count = response?.data?.count ?? response?.count ?? 0;
        setTotalResumes(count);
      } catch (error) {
        console.error('ResumeCountContext: Error refreshing resume count:', error);
      }
    }
  }, [isAuthenticated]);

  // Initial fetch only when authenticated
  useEffect(() => {
    refreshResumeCount();
  }, [refreshResumeCount]);

  return (
    <ResumeCountContext.Provider value={{ totalResumes, updateResumeCount, setResumeCount, refreshResumeCount }}>
      {children}
    </ResumeCountContext.Provider>
  );
};

export const useResumeCount = () => {
  const context = useContext(ResumeCountContext);
  if (!context) {
    throw new Error('useResumeCount must be used within a ResumeCountProvider');
  }
  return context;
}; 